import React from "react";

const TaskOnSiteStatusIcon = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" rx="20" fill="#30BE00" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.116 19.0304C11.7906 19.0304 11.6276 18.6523 11.8577 18.4311L19.7417 10.8528C19.8843 10.7157 20.1157 10.7157 20.2583 10.8528L28.1423 18.4311C28.3724 18.6523 28.2094 19.0304 27.884 19.0304H25.9403V26.8989C25.9403 27.0928 25.7767 27.25 25.575 27.25H14.425C14.2233 27.25 14.0597 27.0928 14.0597 26.8989V19.0304H12.116Z"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default TaskOnSiteStatusIcon;
